<template>
    <div>        
        <!-- 상단 제목 -->
      <div :aria-label="`${page_title}`" class="topbanner">
        <h2 aria-hidden="true">센터소개</h2>
      </div>
        <!--// 상단 제목 -->
        <!-- 메인 컨텐츠 영역 -->
        <article class="main_contents">
            <div class="main_contents_insub" v-html="page_contents"></div>
        </article>
        <!--// 메인 컨텐츠 영역 -->        
    </div>
</template>

<script>
export default {
    data() {
        return {
            page_title: "",
            page_contents: ""
        }
    },
    computed: {
        c_no: function() {
            return this.$route.params.c_no
        }
    },
    watch: {
        c_no: function() {
            this.loadPageContents();
        }
    },
    mounted() {
        this.loadPageContents();
    },
    methods: {
        loadPageContents() {
            this.$http.get('/api/sub.do',{
                params: {
                    c_no: this.c_no
                }
            }).then((response) => {
                if(response.data.retval == this.CONSTANT.SUCCESS) {
                    this.page_title = response.data.pageInfo.title;
                    this.page_contents = response.data.pageInfo.contents;                    
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/Sub.vue